// extracted by mini-css-extract-plugin
module.exports = {"mallList__list":"style_mallList__list__1RCr6","skeleton-list":"style_skeleton-list__7hqcj"};